import React, { FC, useMemo, useRef, useState } from 'react';

import DataGrid, { Column, FilterRow, Lookup, Pager, Paging } from 'devextreme-react/data-grid';

import { AppCard, AppLayoutTop } from 'components/appComponents';
import ClaimsProvider from 'components/claimsBlock';
import { Button } from 'devextreme-react';
import $createDataSource from 'utils/create-data-souce-instance';
import $createStore from 'utils/create-store-instance';

import { useGetFactoryFullNamesQuery } from 'bus/factory/services/services';

import { CreateEditModal } from './components';

const InitialBalance: FC = () => {
  const refGrid = useRef<DataGrid | null>(null);

  const dataSource: any = useMemo(() => {
    return $createDataSource('/v1/MaterialBalance/InBalance', ['factoryId', 'materialId']);
  }, []);

  const { data } = useGetFactoryFullNamesQuery();

  const [isVisibleAddModal, setIsVisibleAddModal] = useState(false);
  const [openId] = useState<number | null>(null);

  const handleAddButton = () => {
    setIsVisibleAddModal(true);
  };

  const refreshGrid = () => refGrid.current?.instance.refresh();

  const storeMaterial: any = useMemo(() => {
    return $createStore('/v1/Material', 'id');
  }, []);

  return (
    <div className="container-dev">
      <AppLayoutTop title="Начальные остатки">
        <ClaimsProvider claimsBlock={['CanLookAndEditStartMaterialRemains']}>
          <Button width={120} text="Создать" type="default" onClick={handleAddButton} />
        </ClaimsProvider>
      </AppLayoutTop>

      <CreateEditModal
        changeVisible={setIsVisibleAddModal}
        id={openId}
        refresh={refreshGrid}
        visible={isVisibleAddModal}
      />

      <AppCard>
        <DataGrid
          dataSource={dataSource}
          showBorders={false}
          loadPanel={{
            enabled: true,
            text: 'Загрузка',
          }}
          ref={refGrid}
          remoteOperations={true}
        >
          <FilterRow visible={true} />

          <Column dataField="date" caption="Дата" dataType="date" />
          <Column dataField="quantity" caption="Объем" />
          <Column dataField="factoryId" caption="Площадка">
            <Lookup dataSource={data} valueExpr="id" displayExpr="name" />
          </Column>

          <Column dataField="materialId" caption="Материал">
            <Lookup dataSource={storeMaterial} valueExpr="id" displayExpr="name" />
          </Column>

          {/* <Column
            dataField="actions"
            caption=""
            width={120}
            cellRender={(data) => (
              <>
                <ClaimsProvider claimsBlock={['all']}>
                  <Button
                    icon="edit"
                    type="default"
                    stylingMode="text"
                    onClick={() => {
                      setOpenId(data.data.id);
                      setIsVisibleAddModal(true);
                    }}
                  />
                </ClaimsProvider>

              </>
            )}
          /> */}

          <Paging defaultPageSize={15} />
          <Pager showPageSizeSelector={true} allowedPageSizes={[15, 30, 50, 100]} />
        </DataGrid>
      </AppCard>
    </div>
  );
};

export default InitialBalance;
